import type { IconProps } from './types';

const CloseCircle: React.FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 1024 1024" {...props}>
    <path
      fill={color}
      d="M512 85.333c-235.093 0-426.667 191.573-426.667 426.667s191.573 426.667 426.667 426.667 426.667-191.573 426.667-426.667-191.573-426.667-426.667-426.667zM655.36 610.133c12.373 12.373 12.373 32.853 0 45.227-6.4 6.4-14.507 9.387-22.613 9.387s-16.213-2.987-22.613-9.387l-98.133-98.133-98.133 98.133c-6.4 6.4-14.507 9.387-22.613 9.387s-16.213-2.987-22.613-9.387c-5.742-5.808-9.289-13.796-9.289-22.613s3.547-16.805 9.292-22.616l98.13-98.13-98.133-98.133c-5.742-5.808-9.289-13.796-9.289-22.613s3.547-16.805 9.292-22.616l-0.003 0.003c12.373-12.373 32.853-12.373 45.227 0l98.133 98.133 98.133-98.133c12.373-12.373 32.853-12.373 45.227 0s12.373 32.853 0 45.227l-98.133 98.133 98.133 98.133z"
    />
  </svg>
);

export default CloseCircle;
